import React from 'react'
import Settings from '../../Settings'
import {Hamburger} from './../common/Hamburger'
import {Page} from './../common/StyledComponents'
import {Title, Back, Container, Button} from './Components'

import background from './../../theme/img/category-background.png'

export const Category = ({
  match: {
    params: {locale, categoryKey},
  },
}) => {
  const hasMultipleCategories = Settings.categories.length !== 1
  const category = Settings.categories.find(category => category.key === categoryKey)

  return (
    <Page background={background}>
      {hasMultipleCategories ? <Hamburger to={`/${locale}`} /> : null}
      {hasMultipleCategories ? <Back to={`/${locale}`} locale={locale} /> : null}
      <Title image={category.title[locale]} />
      <Container>
        {category.videos.map(video => (
          <Button to={`/${locale}/category/${categoryKey}/video/${video.key}`} key={video.key}>
            <img src={video.img[locale]} alt={video.label} />
          </Button>
        ))}
      </Container>
    </Page>
  )
}
